import { useCallback, useEffect } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import InfoBox from '../../../info-box';

type Props = {
    onComplete?: () => void
}

const Task105: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    const { task } = useTask('t-105');

    useEffect(() => {
        onComplete();
    }, [onComplete])

    return <div className="task task-105">
        <h2>zadanie 5</h2>
        <h3>{task?.title}</h3>
        <p>
            Pamiętacie książkową bohaterkę, która jest tak silna, że potrafi podnieść nawet konia? Ma dziewięć lat, rude włosy splecione w odstające warkocze i piegi. Jest bardzo wesoła, a szelmowski uśmiech prawie nie schodzi jej z twarzy. Czy wiecie już, o kim mowa?<br />
        </p>
        <p>
            Na stronie <a target="_blank" rel="noreferrer" href="https://nocbibliotek.ceo.org.pl/rozgrzewka/">https://nocbibliotek.ceo.org.pl/rozgrzewka/</a> znajdziecie stworzony specjalnie dla Was trening z książką, autorstwa Natalii Puciłowskiej, który na pewno sama Pippi Langstrumpf chętnie by wykonała!
        </p>
        <div className="decor-2"></div>
        <p className="instruction">
            <strong>Zadanie:</strong> Wykonajcie przynajmniej trzy z ćwiczeń zaproponowanych w artykule, a potem przygotujcie swój autorski program treningu czytania.
        </p>
        <InfoBox>
            <p>
                Ciekawostka: Wystarczy tylko 6 minut czytania, by obniżyć nasz poziom stresu aż o 68%! Sprawdził to dr David Lewis z Mindlab International na University of Sussex.
            </p>
        </InfoBox>
    </div>
}

export default Task105;
